export const FILTER_TYPE = 'type';

export const MAINTENANCE_NOTICE = 'MAINTENANCE NOTICE';
export const RELEASE_NOTES = 'RELEASE NOTES';
export const SERVICE_ISSUE = 'Service issue';
export const PLANNED_MAINTENANCE = 'Planned maintenance';
export const SYSTEM_MESSAGE = 'Planned maintenance + warning message';
export const BACK_TO_NORMAL = 'Back to normal';
export const BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE =
  'Back to normal post planned maintenance';

export const NEWS_MANAGEMENT_PERMISSION = 3;

export const TYPE_DEFAULT = 0;
export const TYPE_RELEASE_NOTES = 1;
export const TYPE_SERVICE_ISSUE = 2;
export const TYPE_PLANNED_MAINTENANCE = 3;
export const TYPE_BACK_TO_NORMAL = 4;
export const TYPE_SYSTEM_MESSAGE = 5;
export const TYPE_BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE = 6;

export const getTitleByType = (type) => {
  const titles = {
    [TYPE_RELEASE_NOTES]: RELEASE_NOTES,
    [TYPE_SERVICE_ISSUE]: `${MAINTENANCE_NOTICE}: ${SERVICE_ISSUE}`,
    [TYPE_PLANNED_MAINTENANCE]: `${MAINTENANCE_NOTICE}: ${PLANNED_MAINTENANCE}`,
    [TYPE_BACK_TO_NORMAL]: `${MAINTENANCE_NOTICE}: ${BACK_TO_NORMAL}`,
    [TYPE_SYSTEM_MESSAGE]: `${MAINTENANCE_NOTICE}: ${SYSTEM_MESSAGE}`,
    [TYPE_BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE]: `${MAINTENANCE_NOTICE}: ${BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE}`,
    [TYPE_DEFAULT]: RELEASE_NOTES,
  };

  return titles[type] || titles[TYPE_DEFAULT];
};

export const getColorNameByType = (type = TYPE_DEFAULT) => {
  const mapTypes = {
    [TYPE_RELEASE_NOTES]: 'info',
    [TYPE_SERVICE_ISSUE]: 'error',
    [TYPE_PLANNED_MAINTENANCE]: 'warning',
    [TYPE_BACK_TO_NORMAL]: 'success',
    [TYPE_SYSTEM_MESSAGE]: 'warning',
    [TYPE_BACK_TO_NORMAL_POST_PLANNED_MAINTENANCE]: 'success',
    [TYPE_DEFAULT]: 'info',
  };

  return mapTypes[type];
};

export const defaultType = { id: TYPE_DEFAULT, name: 'All' };
